import React from 'react';

interface ScoreRingProps {
  score: number;
  size?: number;
}

const ScoreRing: React.FC<ScoreRingProps> = ({ score, size = 90 }) => {
  const strokeWidth = 6;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const clampedScore = Math.max(0, Math.min(100, score));
  const offset = circumference - (clampedScore / 100) * circumference;

  const color = 'text-primary';
  const trackColor = 'text-primary/20';

  return (
    <div className="relative shrink-0 flex flex-col items-center" style={{ width: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          strokeWidth={strokeWidth}
          className={`stroke-current ${trackColor}`}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          className={`stroke-current ${color} transition-all duration-500`}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center" style={{ height: size }}>
        <span className={`text-xl font-bold ${color}`}>{clampedScore}</span>
        <span className="text-xs text-muted-foreground">/100</span>
      </div>
      <span className="text-[10px] font-semibold uppercase tracking-widest text-muted-foreground mt-1">Score</span>
    </div>
  );
};

export default ScoreRing;
